import { h } from 'preact';
import { useCallback, useEffect, useState } from 'preact/hooks';
import './style.less';
import Modal from '../../molecules/Modal';
import PrimaryLoader from '../../organisms/PrimaryLoader';
import EventBus from '../../lib/EventBus';
import I18n from '../../lib/I18n';
import { deleteVisitorAccountAndLogout } from '../../lib/Visitor';
import ErrorIcon from '../../molecules/Icon/ErrorIcon';

const DeleteAccountConfirmationModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const hideModal = useCallback(() => setShowModal(false), []);

  const deleteAccount = () => {
    setLoading(true);
    setError(false);
    deleteVisitorAccountAndLogout()
      .then(() => {
        setLoading(false);
        hideModal();
      })
      .catch((e) => {
        setLoading(false);
        setError(e);
        setTimeout(hideModal, 5000);
      });
  };

  useEffect(() => {
    EventBus.addListener(EventBus.TYPE.CONFIRM_DELETE_ACCOUNT, openModal);
    return () => EventBus.removeListener(EventBus.TYPE.CONFIRM_DELETE_ACCOUNT, openModal);
  }, [openModal]);

  return (
    <Modal
      className="delete-account-confirm-modal"
      isVisible={showModal}
      onBackdropClick={hideModal}
    >
      <h3 className="title">
        <ErrorIcon size={28} /> <span>Delete Account</span>
      </h3>
      <p className="confirmation-message">
        {I18n.t('DELETE_ACCOUNT_CONFIRM_MESSAGE') ||
          `Are you sure you want to delete your account? 
          You won't able to retrieve your data back once deleted`}
      </p>
      {error && (
        <p className="error-text">
          {error.message ||
            'Something went wrong while deleting your account. please try again later.'}
        </p>
      )}
      <div className="confirmation-modal-actions">
        <button className="btn confirm-delete" onClick={deleteAccount} disabled={loading}>
          <span>Delete</span>
          {loading && (
            <PrimaryLoader containerStyle={{ margin: 0 }} loaderStyle={{ width: 20, height: 20 }} />
          )}
        </button>
        <button className="btn cancel-delete" onClick={hideModal} disabled={loading}>
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default DeleteAccountConfirmationModal;
